<template>
    <v-footer padless class="footer-container">
      <v-container class="text-center">
        <!-- Logos Section -->
        <v-row justify="center" align="center">
          <v-col class="text-center">
            <img src="https://sadilkhan.github.io/text2cad-project/assets/img/logo_lab_light.png" alt="DFKI Augmented Vision" class="footer-logo" />
          </v-col>
        </v-row>
  
        <!-- Copyright Section -->
        <!-- <v-divider class="my-4"></v-divider> -->
        <!-- <p class="mb-0">
          © 2024 Mohammad Sadil Khan. All rights reserved.
        </p> -->
      </v-container>
    </v-footer>
  </template>
  
  <script>
  export default {
    name: "CustomFooter",
  };
  </script>
  
  <style scoped>
  .footer-logo {
    width: 80%;
    height: auto;
    margin: 0 auto;
    
  }


  .footer-container {
    background: linear-gradient(135deg, #973deb07, #86ceeb10); /* Subtle gradient */
  }
  </style>
  